export default __webpack_public_path__ + "static/media/2a8d6dd60587f30af46758c60836d2cf.png";